﻿import ko from 'knockout';
import $ from 'jquery';
import {ITemplateRow} from "./templaterowfactory"

export class CloneRow implements ITemplateRow {
  public $row: JQuery;
  constructor(private $table: JQuery) {
    this.$row = this.getRow();
  }

  getRow(): JQuery {
    var rowToClone = this.$table.find("tbody tr.et-cloneable-row").eq(0);
    if (rowToClone.length == 0)
      rowToClone = this.$table.find("tbody tr").eq(0);
    var cloneRow = rowToClone.clone();
    this.$table.find("tbody").append(cloneRow);
    this.$row = this.$table.find("tbody tr").last();
    return this.$row;
  }

  public init(): void {
    //create a blank row to use for adding Rows 
    var cloneRow = this.$row;
    cloneRow.attr("data-template", "true");
    cloneRow.find("td input, td select").each(function () {
      var input = $(this);
      var binder = input.attr('data-bind');
      if (binder)
        input.attr("data-bind", input.attr("data-bind").replace("init, ", ""));
      input.val("");
    });
    cloneRow.find("td").contents().filter(function () {
      return (this.nodeType == 3 /*text*/);
    }).remove();

    this.$table.append(cloneRow);
  }
}
